export const BAZZAR_PATH = '/rapbazaar';
export const BAZZAR_MOBILE_PATH = '/rapbazaar-mobile';
export const MY_REWARD_PATH = '/my-rewards';
export const TRANSACTIONS_PATH = '/transactions';
export const REFERRALS_PATH = '/referrals';
export const MY_PROFILE_PATH = '/my-profile';
export const MY_WALLET_PATH = '/my-wallet';
export const TERMS_PATH = '/terms-and-conditions';
export const PRIVACY_PATH = '/privacy-policy';
export const myRewardDetailPath = (id) => `${MY_REWARD_PATH}/${id}`;
export const myRapchikRewardDetailPath = (id) => `${MY_REWARD_PATH}/prize/${id}`;
